// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2109":"912e01dcd5889966","6450":"4eca9bfb1764e9e8","6831":"b5aabe6510d47721"}[chunkId] + ".js";
};